import PropTypes from 'prop-types';
import createSearchService from '@/utils/createSearchService';
import React, { createContext, useContext, useMemo } from 'react';
import AhabService from '@/modules/utils/services/AhabService';
import { useQuery } from 'react-query';

const AHABContext = createContext();

const paramsQuery = {
  size: 999,
  search: ''
};

function AHABProvider ({ children }) {

  const searchMunicipalityService = useMemo(() => createSearchService(AhabService.searchMunicipalities), []);
  const searchOrganizationsService = useMemo(() => createSearchService(AhabService.searchOrganizations), []);

  let { isLoading: isLoadingMunicipality, data: municipalities } = useQuery(['municipalities-query-key'], async () => {
    const { data } = await searchMunicipalityService(paramsQuery);
    return data;
  },
  {
    refetchOnWindowFocus: false
  });

  let { isLoading: isLoadingOrganizations, data: organizations } = useQuery(['organizations-query-key'], async () => {
    const { data } = await searchOrganizationsService(paramsQuery);
    return data;
  },
  {
    refetchOnWindowFocus: false
  });

  return (
    <AHABContext.Provider value={{
      municipalities: municipalities || [],
      isLoadingMunicipalities: isLoadingMunicipality,
      organizations: organizations || [],
      isLoadingOrganizations: isLoadingOrganizations,
    }}>
      {children}
    </AHABContext.Provider>
  );
}

function useAHAB () {
  const context = useContext(AHABContext);
  if (context === undefined) {
    throw new Error('use must be used within a AHABProvider');
  }
  const {
    municipalities,
    isLoadingMunicipalities,
    organizations,
    isLoadingOrganizations,
  } = context;

  return {
    municipalities,
    isLoadingMunicipalities,
    organizations,
    isLoadingOrganizations,
  };
}

AHABProvider.propTypes = {
  children: PropTypes.any
};

export { AHABProvider, useAHAB };
